import styles from "./zoom.module.css";
import parallax from "../parallax";
import { useRef, useEffect } from "react";
import DOMPurify from "dompurify";

const Zoom = ({ textData ,language}) => {
  const textBox = useRef(null);
  useEffect(() => {
    parallax(
      {
        trigger: textBox.current,
        start: "top bottom",
        end: "top top",
        scrub: true,
      },
      textBox.current
    );
  }, []);
  return (
    <div className={styles.ctn}>
      <div className={styles.imgBox1} data-parallax="true">
        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-8-poster${language === 'cn' ? '' : '-en'}.jpg`}
          src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-8${language === 'cn' ? '' : '-en'}.mp4`}
        ></video>
      </div>

      <div className={styles.textBox} ref={textBox}>
        <h2
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text17"]),
          }}
        ></h2>

        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text18"]),
          }}
        ></h5>

        <h6           dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text40"]),
          }}></h6>
      </div>

      <div className={styles.imgBox2} data-parallax="true">
        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-9-poster${language === 'cn' ? '' : '-en'}.jpg`}
          src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-9${language === 'cn' ? '' : '-en'}.mp4`}
        ></video>
      </div>

      <div className={styles.backgroundBox}>
        <div></div>
      </div>
    </div>
  );
};

export default Zoom;
